module.exports = __webpack_public_path__ + "08_mole.37f21264.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer2/08_mole.png
// module id = LFxM
// module chunks = 0